/**
 * Outlook-style scope for series cancel / time-edit.
 * Sent to weplace as the `scope` field on series APIs.
 */
export enum SeriesBookingScope {
  /** Only the opened day (selected occurrence). User-facing: "Only this day". */
  OCCURRENCE = "occurrence",
  /** Opened day plus all later active days in the same series. User-facing: "This day and later". */
  THIS_AND_FUTURE = "thisAndFuture",
  /**
   * Remaining active days from today through the end of the series.
   * Days before today are omitted. User-facing: "All days in the series".
   */
  ENTIRE_SERIES = "entireSeries"
}

/**
 * How series time-edit handles availability conflicts after validation.
 * Sent to weplace as the optional `mode` on update-series-booking-times.
 */
export enum SeriesBookingEditMode {
  /** Validate all scoped days first; if any day blocks, update nothing and return a conflict payload (default). */
  ALL_OR_NOTHING = "allOrNothing",
  /** After the user chooses "Update the free days", apply new times only to non-blocking days in the original scope. */
  SKIP_CONFLICTS = "skipConflicts"
}
